import { SxProps, Theme } from '@mui/material';

export const DpBenefitCouponFrameSX: SxProps<Theme> = {
    minWidth: '220px',
	maxWidth: '220px',
	backgroundColor: '#FFFFFF',
	border: '1px solid #F1F1F1',
	borderRadius: '5px',
};

export const DpBenefitCouponImgSX: SxProps<Theme> = {
	width: '220px',
	height: '67px',
	borderTopLeftRadius: '5px',
	borderTopRightRadius: '5px',
};

export const DpBenefitCouponContentSX: SxProps<Theme> = {
	paddingTop: '5px',
	paddingX: '10px',
	paddingBottom: '10px',
	display: 'flex',
	flexDirection: 'column',
	gap: '5px',
};

export const DpBenefitCouponCategorySX: SxProps<Theme> = ({
	color: '#2D3277',
	fontSize: 'var(--font-size-caption)',
});

export const DpBenefitCouponDescriptionSX: SxProps<Theme> = ({
	color: '#333333',
	fontWeight: 'bold',
	fontSize: 'var(--font-size-caption)',
});

export const DpBenefitCouponCodeFrameSX: SxProps<Theme> = {
	borderTop: '1px dashed #C9C9C9',
	borderLeft: '1px dashed #C9C9C9',
	borderBottom: '1px dashed #C9C9C9',
	flexGrow: 1,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
};

export const DpBenefitCouponCodeSX: SxProps<Theme> = ({
	color: '#333333',
	fontSize: 'var(--font-size-caption)',
	fontWeight: 'bold',
});

export const DpBenefitCouponCopyButtonSX: SxProps<Theme> = (theme) => ({
	backgroundColor: theme.palette.primary.main,
	color: theme.palette.common.white,
	fontSize: 'var(--font-size-caption)',
	fontWeight: 'bold',
	width: '55px',
	height: '30px',
});

export const DpBenefitCouponDateSX: SxProps<Theme> = ({
	color: '#707070',
	fontSize: 'var(--font-size-tiny)',
});
